module.exports = __webpack_public_path__ + "static/media/ic_check-circle-green2.92e99d9b.svg";